import bottle from "@/assets/horse-power-bottle.jpeg";
import hpBox from "@/assets/hp-box.jpeg";
import hpRed from "@/assets/hp-red.jpeg";
import hpFire from "@/assets/hp-fire.jpeg";

export const BRAND = {
  name: "HORSE POWER",
  nameHi: "HORSE POWER",
  tagline: "100% Pure Ayurvedic Strength & Stamina Booster Capsules for Men",
  phone: "7428780672",
  email: "support@horsepowergroup1.in",
  address: "Plot No-479, Industrial Area, Baddi, Himachal Pradesh 173205",
  rating: 4.8,
  reviewCount: 12480,
};

export const BOTTLE_IMG = bottle;

export const GALLERY = [
  { url: bottle, alt: "Horse Power Capsule bottle" },
  { url: hpBox, alt: "Horse Power Capsules - box and bottle" },
  { url: hpFire, alt: "Horse Power Capsules bottle" },
  { url: hpRed, alt: "Horse Power Capsule - Extra Effective" },
];

export const PACKS = [
  {
    id: "1-month",
    title: "1 Month Course",
    sub: "60 Capsules",
    badge: "Starter Pack",
    price: 1499,
    mrp: 2999,
    discount: "50% OFF",
  },
  {
    id: "2-month",
    title: "2 Months Course",
    sub: "120 Capsules",
    badge: "Most Popular",
    price: 2499,
    mrp: 5499,
    discount: "55% OFF",
    popular: true,
  },
  {
    id: "3-month",
    title: "3 Months Course",
    sub: "180 Capsules",
    badge: "Best Value",
    price: 3499,
    mrp: 7999,
    discount: "56% OFF",
  },
];

export const TRUST_BADGES = [
  { icon: "Truck", title: "Fast & Reliable", sub: "Delivery" },
  { icon: "ShieldCheck", title: "Secure", sub: "Checkout" },
  { icon: "BadgeCheck", title: "Original Product", sub: "Guaranteed" },
];

export const BENEFITS = [
  { icon: "Zap", title: "Natural Energy & Stamina", desc: "Helps fight daily fatigue and keeps your energy levels up throughout the day." },
  { icon: "Dumbbell", title: "Strength & Power", desc: "Supports the body's natural strength and endurance." },
  { icon: "Leaf", title: "Stress & Fatigue Relief", desc: "Ayurvedic herbs that promote calmness and relaxation." },
  { icon: "HeartPulse", title: "Daily Wellness & Balance", desc: "Helps maintain everyday health and overall wellness." },
];

export const INGREDIENTS = [
  { name: "Ashwagandha", en: "Ashwagandha Root", desc: "Helps manage daily stress & fatigue and supports energy.", img: "https://images.pexels.com/photos/16122465/pexels-photo-16122465.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500&w=500" },
  { name: "Gokshura", en: "Gokshura", desc: "Helps promote healthy circulation in the body.", img: "https://images.unsplash.com/photo-1681390366427-251f73066f84?crop=entropy&cs=srgb&fm=jpg&q=85&w=500" },
  { name: "Kaunch Beej", en: "Kaunch Beej", desc: "Helps promote a positive mood and an energized life.", img: "https://images.pexels.com/photos/30688215/pexels-photo-30688215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500&w=500" },
  { name: "Safed Musli", en: "Safed Musli", desc: "Helps combat fatigue and support energy levels.", img: "https://images.unsplash.com/photo-1552825898-5896ec192f9c?crop=entropy&cs=srgb&fm=jpg&q=85&w=500" },
  { name: "Shatavari", en: "Shatavari", desc: "Supports activeness and overall wellness.", img: "https://images.pexels.com/photos/36863456/pexels-photo-36863456.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500&w=500" },
];

export const HOW_TO_USE = [
  { step: "1", title: "One capsule, twice a day", desc: "Take one capsule after a meal. Totally safe for daily use." },
  { step: "2", title: "With lukewarm water or milk", desc: "Milk is recommended for better results." },
  { step: "3", title: "For at least 3-4 months", desc: "Take regularly for noticeable results." },
];

export const SPECS = [
  ["Requires Prescription", "No"],
  ["Net Quantity", "60 Capsules (per pack)"],
  ["Item Form", "Capsule"],
  ["Dosage", "Twice a day (1 capsule after meals)"],
  ["Shelf Life", "24 months from MFG date"],
  ["Formula", "Non-hormonal, no known side effects"],
];

export const RATING_BREAKDOWN = [
  { stars: 5, pct: 64, count: 7987 },
  { stars: 4, pct: 20, count: 2496 },
  { stars: 3, pct: 13, count: 1622 },
  { stars: 2, pct: 2, count: 250 },
  { stars: 1, pct: 1, count: 125 },
];

export const REVIEWS = [
  { name: "Rajesh Kumar", city: "Delhi", rating: 5, title: "Great results", text: "After regular use I felt a clear improvement in my overall energy and stamina. The packaging was discreet too.", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=160" },
  { name: "Subhajit Nath", city: "Kolkata", rating: 5, title: "Effective product", text: "Took it consistently for 3 months, fatigue reduced and I feel fresh all day. The COD option was convenient.", img: "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a?crop=entropy&cs=srgb&fm=jpg&q=85&w=160" },
  { name: "Amit Verma", city: "Lucknow", rating: 4, title: "Good ayurvedic option", text: "Completely ayurvedic with no side effects. Delivery was on time.", img: "https://images.pexels.com/photos/4307869/pexels-photo-4307869.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=160&w=160" },
  { name: "Vinod Sharma", city: "Jaipur", rating: 5, title: "Satisfied", text: "I take it daily with milk and noticed a difference in both strength and confidence.", img: "https://images.unsplash.com/photo-1758337779808-6c64838afda1?crop=entropy&cs=srgb&fm=jpg&q=85&w=160" },
];

export const FOOTER_LINKS = {
  "Information": ["About Us", "Contact Us", "FAQ"],
  "Policies": ["Delivery Information", "Privacy Policy", "Return & Refund", "Terms & Conditions"],
};

export const URGENCY_NAMES = [
  "Rajesh K. (Delhi)", "Sunil M. (Mumbai)", "Arun P. (Pune)", "Deepak S. (Jaipur)",
  "Manoj R. (Patna)", "Vikas G. (Indore)", "Sanjay T. (Lucknow)", "Ravi N. (Surat)",
];
